import styled from "styled-components";

export const Container = styled.div`
  max-width: 115rem;
  padding: 0 2rem;
  margin: 0 auto;
`;